module.exports = __webpack_public_path__ + "img/songfile-logo.10fe4384.png";